import React, { useEffect } from "react";
import styles from "../Footer2/Footer2.module.css";

import FooterBottom from "./FooterBottom";

const Footer2 = () => {


  useEffect(() => {
    // The HubSpot embed is ~190 KB and this footer renders on every page, so the
    // script is only fetched once the newsletter form nears the viewport.
    let requested = false;

    const createForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: "19647191",
          formId: "1e7b102a-d198-4b62-89d7-faa835387d80",
          region: "na1",
          target: "#hubspotFooterForm",
          css: "",
        });
      }
    };

    const loadHubspot = () => {
      if (requested) return;
      requested = true;

      // Another section on this page may have already embedded HubSpot.
      if (window.hbspt) {
        createForm();
        return;
      }

      let script = document.querySelector("script[data-hsforms-embed]");
      if (!script) {
        script = document.createElement("script");
        script.src = "//js.hsforms.net/forms/embed/v2.js";
        script.charset = "utf-8";
        script.type = "text/javascript";
        script.setAttribute("data-hsforms-embed", "true");
        document.body.appendChild(script);
      }
      script.addEventListener("load", createForm);
    };

    // injects CSS
    const style = document.createElement("style");
    style.innerHTML = `
#hubspotFooterForm {
  min-height: 60px;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
}
#hubspotFooterForm form {
  display: flex !important;
  gap: 15px !important;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 !important;
}
#hubspotFooterForm .hs-form-field > label {
  display: none !important;
}
#hubspotFooterForm .hs-form-field {
  position: relative;
  margin-bottom: 0 !important; /* remove bottom margin */
  min-height: 50px; /* reserve space for errors */
}
#hubspotFooterForm input[type="text"],
#hubspotFooterForm input[type="email"],
#hubspotFooterForm .hs-input:not([type="submit"]):not([type="checkbox"]) {
  flex: 1;
  min-width: 200px;
  height: 46px;
  padding: 10px 16px;
  border: 1px solid white;
  border-radius: 6px;
  background: transparent;
  color: white;
  outline: none;
  font-size: 16px !important;
  box-sizing: border-box;
}
#hubspotFooterForm input::placeholder {
  color: white !important;
  opacity: 0.9 !important;
}
#hubspotFooterForm input[type="submit"] {
  background: white;
  color: #009fe3;
  height: 46px;
  padding: 0 24px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  min-width: 140px;
  display: inline-block;
  margin: 0 !important; 
}
/* Errors sit in normal flow under their own input instead of overlapping the next row */
#hubspotFooterForm .hs-error-msgs {
  position: static !important;
  list-style: none !important;
  padding-left: 0 !important;
  margin: 4px 0 0 !important;
  text-align: left;
}
#hubspotFooterForm .hs-error-msgs li {
  margin: 0 !important;
  padding: 0 0 0 4px !important;
}
#hubspotFooterForm .hs-error-msgs label,
#hubspotFooterForm .hs-error-msgs li {
  color: white !important;
  font-family: "MokokoRegular", "MokokoRegular-fallback", sans-serif !important;
  font-size: 13px !important;
  line-height: 1.3;
}
#hubspotFooterForm .hs_error_rollup {
  display: none !important;
}
#hubspotFooterForm .hs_submit {
  position: relative !important;
  display: inline-block !important;
  margin: 0 !important;
}
#hubspotFooterForm .submitted-message {
  font-size: 20px !important;
  font-family: 'Arial', sans-serif !important;
  color: #FFFFFF !important;
  font-weight: 400;
}
`;
    document.head.appendChild(style);

    // Labels are hidden above, so every field needs a placeholder.
    const placeholders = {
      firstname: "First name",
      lastname: "Last name",
      city: "City",
      state: "State/Region",
      email: "Email address",
      mobilephone: "Mobile phone number",
    };

    const observer = new MutationObserver(() => {
      Object.entries(placeholders).forEach(([name, text]) => {
        const input = document.querySelector(
          `#hubspotFooterForm [name='${name}']`
        );
        if (input && input.getAttribute("placeholder") !== text) {
          input.setAttribute("placeholder", text);
        }
      });
    });


    const formContainer = document.getElementById("hubspotFooterForm");
    if (formContainer) {
      observer.observe(formContainer, { childList: true, subtree: true });
    }

    // The embed must not compete with the initial paint, but it also must not
    // make the user wait once they reach the footer. So it starts on whichever
    // happens first: the footer coming into range, or the page finishing load.
    let viewportObserver;
    let idleTimer;

    const start = () => {
      if (viewportObserver) viewportObserver.disconnect();
      clearTimeout(idleTimer);
      window.removeEventListener("load", scheduleAfterLoad);
      loadHubspot();
    };

    function scheduleAfterLoad() {
      idleTimer = setTimeout(start, 1500);
    }

    if (formContainer && typeof IntersectionObserver !== "undefined") {
      viewportObserver = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) start();
        },
        { rootMargin: "2000px" }
      );
      viewportObserver.observe(formContainer);
    }

    if (document.readyState === "complete") scheduleAfterLoad();
    else window.addEventListener("load", scheduleAfterLoad);

    return () => {
      observer.disconnect();
      if (viewportObserver) viewportObserver.disconnect();
      clearTimeout(idleTimer);
      window.removeEventListener("load", scheduleAfterLoad);
    };
  }, []);

  return (
    <div>
      <footer className={styles.footer}>
        <div className={styles.innerFooter}>
          <div className={styles.innerFooterPart}>
            <div className={styles.newsletterSection}>
              <h2>Subscribe to our newsletter</h2>
              <div className={styles.inputGroup}>
       
                <div id="hubspotFooterForm"></div>
              </div>
            </div>
            <div className={styles.newsletterImg}>
              <img loading="lazy" src="/Images/footerImg2.webp" alt="young woman with freckles and green eyes looks at camera" />
            </div>
          </div>
        </div>
        <div>
          <FooterBottom />
        </div>

      </footer>
    </div>
  );
};

export default Footer2;
